import React from 'react';
import { render } from 'react-dom';
import { ThemeProvider } from '@zendeskgarden/react-theming';

import '@zendeskgarden/react-textfields/dist/styles.css';
import '@zendeskgarden/react-modals/dist/styles.css';

import ContactForm from '../components/ContactForm';

render(
  <ThemeProvider>
    <ContactForm />
  </ThemeProvider>,
  document.querySelector('#talalla-contact-container'),
);
